//import { OffersBlockProps } from '../../../components';

export const mapDirectusOffersBlock = block => {
  return {};
};
